import React from 'react';
import CircleClip from './CircleClip';

const PlayIcon = ({rotate}) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    className="spl-icon"
  >
    <CircleClip rotate={rotate} start="315 18 18" stop="495 18 18" />
    <polygon
      points="13 12, 25 18, 13 24"
      fill="#FFFFFF"
    />
  </svg>
);

PlayIcon.propTypes = {};

export default PlayIcon;